import { Component, inject, input, LOCALE_ID, OnInit, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LookupService } from '../../../../services/pharmacy/lookup.service';
import { PharmacySegmentVTO } from '../../../../services/pharmacy/lookup.model';

@Component({
  selector: 'app-pharmacy-segment',
  imports: [ReactiveFormsModule],
  templateUrl: './pharmacy-segment.html',
  styleUrl: './pharmacy-segment.scss',
})
export class PharmacySegment implements OnInit {
  private pharmacyService = inject(LookupService);
  private locale = inject(LOCALE_ID);
  pharmacyForm = input.required<FormGroup>();
  segments = signal<PharmacySegmentVTO[]>([]);

  ngOnInit(): void {
    this.pharmacyService.getPharmacySegments().subscribe({
      next: (res) => {
        this.segments.set(res.list);
      },
      error: () => {},
    });
  }

  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }
}
